const JWT_KEY = 'LangHub-jwtToken';

function isTokenExpired(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
}

export function getJwtToken(): string | null {
  const token = localStorage.getItem(JWT_KEY);
  if (!token || isTokenExpired(token)) {
    return null;
  }
  return token;
}

export function setJwtToken(token: string): void {
  localStorage.setItem(JWT_KEY, token);
}

export function removeJwtToken(): void {
  localStorage.removeItem(JWT_KEY);
}

// --- Saved original location ---
// The Midway OAuth flow redirects the browser away and back; we stash where the
// user was before the round-trip so FederatedAuth can restore it afterwards.
const savedOriginalUserLocationTag = 'LangHub-ORIGINAL_USER_LOCATION';
const majorVersion = 'V0';
const minorVersion = '.01';

export const savedOriginalUserLocationKey: string =
  savedOriginalUserLocationTag + '-' + majorVersion + minorVersion;

export const readFromLocal = (key: string) => {
  const data = localStorage.getItem(key);
  try {
    return JSON.parse(data as string);
  } catch {
    return null;
  }
};

export const writeToLocal = (key: string, data: unknown) => {
  localStorage.setItem(key, JSON.stringify(data));
};
